<template>
  <div class="box-container hvh-flex center">
    <div class="hvh-flex wrap" v-resize="setDimensions">
      <ActicsMenuBox class="col-12 col-sm-6 col-md-4 box" :style="boxStyle" :title="item.title" :description="item.description" v-for="(item, ind) in $store.state.actics.menuItems" :key="ind">
        <v-btn class="hvh-btn hvh-btn--primary mt-4 mb-0" :outline="item.buttonText === 'LEARN MORE'" small color="#002F6C" @click="goTo(item.link)">{{ item.buttonText }}</v-btn>
      </ActicsMenuBox>
    </div>
  </div>
</template>
  
<script>
import { Debouncer } from '../../../libraries/common';
import ActicsMenuBox from './ActicsMenuBox.vue';
export default {
  components: { ActicsMenuBox },
  noExport: true,
  data() {
    return {
      boxHeight: null,
      debouncer: new Debouncer(10),
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    boxStyle() {
      return this.boxHeight ? { minHeight: `${this.boxHeight}px` } : {};
    },
  },
  methods: {
    setDimensions() {
      this.debouncer.clear()
        .push(() => {
          this.boxHeight = null;
          this.$nextTick(() => {
            this.boxHeight = this.$children.max(f => f.$el.offsetHeight);
          });
        });
    },
  },
  watch: {
    '$store.state.actics.menuOpened'() {
      new Array(5).fill(0).forEach((_, ind) => setTimeout(this.setDimensions, (ind + 1) * 100));
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisActicsMenuBoxes'] = this;
    this.setDimensions();
  },
}
</script>

<style lang="scss" scoped>
.box {
  max-width: 340px;
  min-width: 340px;
}

.box-container {
  flex: 1 1 100%;
  margin: auto;
  padding: 24px;
  width: 100%;
}

@media only screen and (min-width: 960px) {
  .box-container {
    max-width: 730px;
  }
}
@media only screen and (min-width: 1264px) {
  .box-container {
    max-width: 1070px;
  }
}
@media only screen and (min-width: 1904px) {
  .box-container {
    max-width: 1410px;
  }
}
@media only screen and (min-width: 2500px) {
  .box-container {
    max-width: 1750px;
  }
}
</style>